import React from 'react';
import { PixelCrop } from 'react-image-crop';
import { AspectRatiosEnum } from '../editImage';
import { useTypedSelector } from '../../../../../hooks/useTypeSelector';
import { useDispatch } from 'react-redux';
import { setSelectedCropARType } from '../../../../../redux/actions/cropAction';

type ImageCropRatiosType = {
	completedCrop?: PixelCrop;
	previewCanvasRef: React.RefObject<HTMLCanvasElement>;
	image?: HTMLImageElement;
	setImageModalPreviewAspectRatio: (aspectRatio: string) => void;
	setIsImageModalPreviewOpen: (isModalOpen: boolean) => void;
	setPreviewImageSrc: (imageSrc: string) => void;
	src: string;
};

export const ImageCropRatios = (props: ImageCropRatiosType) => {
	// const {
	// 	newStandardCroppedImagePreview,
	// 	oldStandardCroppedImagePreview,
	// 	wideCroppedImagePreview,
	// 	portraitCroppedImagePreview
	// } = useTypedSelector((state) => state.crop);

	return (
		<div>
			<>
				{!!props.completedCrop && (
					<canvas
						ref={props.previewCanvasRef}
						className="hidden"
						style={{
							border: '1px solid black',
							objectFit: 'contain',
							width: props.completedCrop.width,
							height: props.completedCrop.height
						}}
					/>
				)}
				{/* {props.image != null ? ( */}
				<div className="flex flex-wrap space-x-3  mx-auto justify-center">
					<ImgRatio
						key={1}
						image={props.image != null ? props.image.src : props.src}
						aspect={'aspect-[16/10]'}
						text={'New Standard (16:10)'}
						setImageModalPreviewAspectRatio={
							props.setImageModalPreviewAspectRatio
						}
						setIsImageModalPreviewOpen={props.setIsImageModalPreviewOpen}
						setPreviewImageSrc={props.setPreviewImageSrc}
						selectedCrop={AspectRatiosEnum.NEW_STANDARD}
					/>
					<ImgRatio
						key={2}
						image={props.image != null ? props.image.src : props.src}
						aspect={'aspect-[21/9]'}
						text={'Wide (21:9)'}
						setImageModalPreviewAspectRatio={
							props.setImageModalPreviewAspectRatio
						}
						setIsImageModalPreviewOpen={props.setIsImageModalPreviewOpen}
						setPreviewImageSrc={props.setPreviewImageSrc}
						selectedCrop={AspectRatiosEnum.WIDE}
					/>
					<ImgRatio
						key={3}
						image={props.image != null ? props.image.src : props.src}
						aspect={'aspect-[4/3]'}
						text={'Old Standard (4:3)'}
						setImageModalPreviewAspectRatio={
							props.setImageModalPreviewAspectRatio
						}
						setIsImageModalPreviewOpen={props.setIsImageModalPreviewOpen}
						setPreviewImageSrc={props.setPreviewImageSrc}
						selectedCrop={AspectRatiosEnum.OLD_STANDARD}
					/>
					<ImgRatio
						key={4}
						image={props.image != null ? props.image.src : props.src}
						aspect={'aspect-[9/16]'}
						text={'Portrait (16:9)'}
						setImageModalPreviewAspectRatio={
							props.setImageModalPreviewAspectRatio
						}
						setIsImageModalPreviewOpen={props.setIsImageModalPreviewOpen}
						setPreviewImageSrc={props.setPreviewImageSrc}
						selectedCrop={AspectRatiosEnum.PORTRAIT}
					/>
				</div>
			</>
		</div>
	);
};

const ImgRatio = ({
	image,
	aspect,
	text,
	setImageModalPreviewAspectRatio,
	setPreviewImageSrc,
	setIsImageModalPreviewOpen,
	selectedCrop
}: {
	image: string;
	aspect: string;
	text: string;
	setImageModalPreviewAspectRatio: (apectRatio: string) => void;
	setPreviewImageSrc: (apectRatio: string) => void;
	setIsImageModalPreviewOpen: (isModalOpen: boolean) => void;
	selectedCrop?: AspectRatiosEnum;
}) => {
	const dispatch = useDispatch();
	return (
		<div
			className="flex flex-col mb-3"
			onClick={() => {
				setImageModalPreviewAspectRatio(aspect);
				setIsImageModalPreviewOpen(true);
				setPreviewImageSrc(image);
				if (selectedCrop) {
					console.log('selected crop', selectedCrop);
					dispatch(setSelectedCropARType(selectedCrop));
				}
			}}
		>
			<img
				className={`h-40 rounded-lg block object-cover object-center ${aspect} mb-1`}
				src={image}
			/>
			<h3 className="font-semibold text-sm dark:text-gray-400 text-gray-800 transition-all duration-500">
				{text}
			</h3>
		</div>
	);
};
